import React from 'react'
import './style.scss'
import { FiTrash } from 'react-icons/fi'

function ButtonRemover({ onClick }) {
    return (
        <div onClick={onClick} className={`button button-remove`} data-tip="Remover">
            <FiTrash />
        </div>
    )
}

export default ButtonRemover